import { token, typography, element } from "@universityofmaryland/web-styles-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { combineStyles } from "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-token-library";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/events";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-styles-library/typography";
import { fullscreen } from "../../../atomic/buttons/fullscreen.js";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import { createCompositeCarouselOverlay } from "../elements/overlay.js";
import { createCompositeCarouselImage } from "../elements/image.js";
import { createCarouselIndicatorWrapper } from "../elements/indicator-wrapper.js";
import { createLayoutImageContainer } from "../../../layout/image.js";
const ATTRIBUTE_REFERENCE = "data-reference";
const createCompositeCarouselImageStandard = (props) => (() => {
  const {
    images,
    isThemeDark,
    isFullScreenOption,
    isToggleCaption = true
  } = props;
  const overlayCarousel = createCompositeCarouselOverlay({
    images,
    isToggleCaption
  });
  let buttonStyles = "";
  const CreateTextContainer = ({
    headlines,
    texts,
    reference
  }) => {
    const headline = headlines && headlines.find(
      (item) => item.getAttribute(ATTRIBUTE_REFERENCE) === reference
    );
    const richText = texts && texts.find(
      (item) => item.getAttribute(ATTRIBUTE_REFERENCE) === reference
    );
    if (!headline && !richText) return null;
    const createHeadline = () => {
      if (!headline) return null;
      return new ElementBuilder(headline).withClassName("carousel-image-standard-slide-headline").styled(typography.sans.large);
    };
    const createRichText = () => {
      if (!richText) return null;
      return new ElementBuilder(richText).withClassName("carousel-image-standard-slide-rich-text").withStyles({
        element: {
          marginTop: token.spacing.min,
          color: token.color.gray.dark,
          ...element.text.rich.simple,
          ...isThemeDark && {
            color: token.color.white,
            ...element.text.rich.simpleDark
          }
        }
      });
    };
    const textChildren = [createHeadline(), createRichText()].filter(
      (child) => child !== null
    );
    return new ElementBuilder().withClassName("carousel-image-standard-slide-text").withStyles({
      element: {
        padding: token.spacing.md,
        paddingBottom: 0,
        backgroundColor: token.color.gray.lightest,
        ...isThemeDark && {
          backgroundColor: token.color.black,
          "& *": { color: token.color.white }
        },
        [`@media (${token.media.queries.tablet.min})`]: {
          paddingBottom: token.spacing.md
        },
        "@container (min-width: 500px)": {
          padding: token.spacing.lg
        }
      }
    }).withChildren(...textChildren).build();
  };
  const CreateImageContainer = ({
    image,
    isFullScreenOption: isFullScreenOption2,
    setFullScreen,
    index: index$1
  }) => {
    const imageBlock = createLayoutImageContainer({
      image,
      showCaption: true,
      isToggleCaption
    });
    const standardSlideWrapperElement = new ElementBuilder().withClassName("carousel-image-standard-slide-wrapper").withStyles({
      element: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& > *": { height: "100%" },
        "& img": { objectFit: "contain", width: "100%", height: "100%" }
      }
    }).withChild(imageBlock).build();
    if (isFullScreenOption2) {
      const buttonFullscreen = fullscreen.create({
        callback: setFullScreen,
        index: index$1
      });
      imageBlock.element.appendChild(buttonFullscreen.element);
      buttonStyles += buttonFullscreen.styles;
    }
    return new ElementBuilder().withClassName("carousel-image-standard-slide-image").withStyles({
      element: {
        position: "relative",
        backgroundColor: token.color.black,
        ...isThemeDark && { backgroundColor: token.color.gray.darker }
      }
    }).withChild(standardSlideWrapperElement).build();
  };
  const CreateSlide = (slideProps) => {
    const { images: images2, setFullScreen } = slideProps;
    const clonedImages = images2.map(
      (image) => image.cloneNode(true)
    );
    const createStandardSlide = ({
      image,
      index
    }) => {
      const reference = image.getAttribute(ATTRIBUTE_REFERENCE);
      const imageContainerModel = CreateImageContainer({
        ...slideProps,
        image,
        setFullScreen,
        index
      });
      const textContainerModel = CreateTextContainer({
        ...slideProps,
        reference
      });
      const slideChildren = [imageContainerModel, textContainerModel].filter(
        (child) => child !== null
      );
      return new ElementBuilder().withClassName("carousel-image-standard-slide").withChildren(...slideChildren).build();
    };
    return clonedImages.map((image, index) => {
      return createStandardSlide({ image, index });
    });
  };
  const slideModels = CreateSlide({
    ...props,
    setFullScreen: overlayCarousel.events.setFullScreen
  });
  const slides = slideModels.map((model) => model.element);
  const slideStyles = slideModels.reduce(
    (accumulator, model) => accumulator + (model.styles ?? ""),
    ""
  );
  const carousel = createCompositeCarouselImage({
    slides,
    isThemeDark,
    callback: (activeIndex) => {
      indicatorWrapperModel.position(activeIndex);
    },
    maxHeight: 500,
    includeButtonWrapper: false
  });
  const indicatorWrapperModel = createCarouselIndicatorWrapper({
    count: images.length,
    callback: carousel.events.EventMoveTo,
    isThemeDark,
    isBackground: true
  });
  const indicatorContainerModel = new ElementBuilder().withClassName("carousel-image-standard-indicator").withStyles({
    element: {
      backgroundColor: token.color.gray.lightest,
      ...isThemeDark && { backgroundColor: token.color.black },
      [`@media (${token.media.queries.desktop.min})`]: {
        paddingBottom: token.spacing.lg
      }
    }
  }).withChild(indicatorWrapperModel).build();
  const buttonWrapperModel = new ElementBuilder().withClassName("carousel-image-standard-buttons").withStyles({
    element: {
      display: "flex",
      justifyContent: "center",
      gap: token.spacing.min,
      padding: `${token.spacing.md} 0`,
      backgroundColor: token.color.gray.lightest,
      ...isThemeDark && { backgroundColor: token.color.black }
    }
  }).withChildren(carousel.buttons.prev, carousel.buttons.next).build();
  const containerModel = new ElementBuilder().withClassName("carousel-image-standard-container").withStyles({
    element: {
      position: "relative",
      backgroundColor: token.color.gray.lightest,
      ...isThemeDark && { backgroundColor: token.color.black }
    }
  }).withChildren(carousel, indicatorContainerModel, buttonWrapperModel).build();
  const declarationModel = new ElementBuilder().withClassName("carousel-image-standard-declaration").withStyles({
    element: { containerType: "inline-size" }
  }).withChild(containerModel).withEvents({ SetEventReize: carousel.events.EventResize }).build();
  declarationModel.styles = combineStyles(
    slideStyles,
    overlayCarousel.styles,
    buttonStyles,
    declarationModel.styles
  );
  images[images.length - 1].addEventListener("load", carousel.events.Load);
  if (isFullScreenOption) {
    const wrapperModel = new ElementBuilder().withChild(declarationModel).withModifier((element2) => {
      element2.insertAdjacentElement("afterbegin", overlayCarousel.element);
    }).withEvents({ SetEventReize: carousel.events.EventResize }).build();
    return wrapperModel;
  }
  return declarationModel;
})();
export {
  createCompositeCarouselImageStandard
};
//# sourceMappingURL=standard.js.map
